
import React from "react";
import './StudentRegistered.css'

const StudentRegistered = () => {

    return (
        <div className="container active sign-up-container" id="container">
            <h1 className="congrats">Congratulations, Student Name!</h1>
            <h5 className="registered">You have successfully registered for the class "Class Name"</h5>
            <h5 className="registered second">Follow the link to get started: linkkkkkkk</h5>
        </div>
    )

}


export default StudentRegistered;
